import { useNavigate } from 'react-router-dom'

// Components
import { Button } from '../../components/Button/Button'
import { Rectangle } from '../../components/Rectangle/Rectangle'
import { AnimatedScreenWrapper } from '../../components/AnimatedScreenWrapper/AnimatedScreenWrapper'

// Svg
import { ExtractedEmail, Logo } from '../../assets'

// Styles
import './secondVerification.scss'

export interface VerificationSecondScreenProps {}

export const VerificationSecondScreen = (props: VerificationSecondScreenProps) => {
  const {} = props
  let navigate = useNavigate()

  const onHandleNext = () => {
    navigate('/subscriptions')
  }

  return (
    <div className="full-screen second-verification-bg">
      <AnimatedScreenWrapper>
        <div className="grid">
          <div>
            <Logo />
          </div>
          <Rectangle>
            <h5 className="secondary-title">
              Awesome! You just created <br /> your Presence account.
            </h5>
            <div className="center" style={{ padding: '10px 0 32px 0' }}>
              <ExtractedEmail />
            </div>
            <Button onClick={onHandleNext}>next</Button>
          </Rectangle>
        </div>
      </AnimatedScreenWrapper>
    </div>
  )
}
